// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"branch_promotion_manager__3nKgO","card":"branch_card__1Wt-k"};